module.exports = __webpack_public_path__ + "media/images/a6-8f518b7611ca45120c3ed2684f41b7c6.jpg";